/* eslint-disable react/prop-types */
import React, { useState } from 'react'

import { useStyles } from './SelectFilter_style'
import { Box, FormControl, MenuItem, Select } from '@material-ui/core'

import IconFactory from 'icons/IconFactory/IconFactory'
import { DROPDOWN_STYLE_MENU_PROPS } from 'assets/StyleHelper'
import useJobIcon from 'hooks/useJobIcon'
import useJobIconColor from 'hooks/useJobIconColor'
import SVGFactory from 'shared/icons/SVGFactory/SVGFactory'

const OpenIcon = (props) => {
    const { open } = props

    if (open) {
        return <IconFactory icon='up-solid' fontSize='12px' color='black' />
    } else {
        return <IconFactory icon='down-solid' fontSize='12px' color='black' />
    }
}

const SelectFilter = (props) => {
    const { value, name, onChange, collection, className, placeholder, defaultValue } = props
    const [open, setOpen] = useState(false)
    const classes = useStyles()

    const handleOpenToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }

    return (
        <FormControl className={classes.formControl} required onClick={() => setOpen(!open)}>
            <Select
                className={`${classes.select} ${className}`}
                value={value}
                name={name}
                MenuProps={{
                    ...DROPDOWN_STYLE_MENU_PROPS,
                    disableScrollLock: false,
                    PaperProps: {
                        style: {
                            borderRadius: 16,
                            maxHeight: 450,
                            minWidth: 240,
                            boxShadow: '4px 4px 0px 0px var(--background-black)',
                            border: '2px solid var(--foreground-black)',
                            backgroundColor: 'var(--background-white)'
                        }
                    }
                }}
                open={open}
                onClick={handleOpenToggle}
                disableUnderline
                onChange={onChange}
                placeholder={placeholder}
                IconComponent={() => <OpenIcon open={open}/>}
                displayEmpty
            >
                {defaultValue && <MenuItem className={classes.menuItem} value={null}>{defaultValue}</MenuItem>}
                {collection.map((item, itemKey) => {
                    return (
                        <MenuItem className={classes.menuItem} key={itemKey.toString()} value={item.value}>
                            <Box className={classes.iconContainer} style={{ backgroundColor: useJobIconColor(item.value) }}>
                                <SVGFactory name={useJobIcon(item.value)} width='18px' height='18px' />
                            </Box>
                            <span>{item.name}</span>
                        </MenuItem>
                    )
                })}
            </Select>
        </FormControl>
    )
}

export default SelectFilter
